import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class OnDutyService {
  private apiUrl = environment.apiURL + 'rest/usuario/onduty';

  constructor(
    private http: HttpClient,
  ) { }

  /**
   * Get the list of staff members who are on duty
   * @returns Observable with the on-duty staff information
   */
  getOnDutyStaff(): Observable<any> {
    // The API expects a JSON object with action and apiKey
    const payload = {
      apiKey: environment.apiKey
    };

    return this.http.post<any>(this.apiUrl, payload);
  }
}
